import { defineStore } from "pinia";
import * as _debug from "debug";
import ApiClient from "@/lib/ApiClient";
import { createStore } from "../storeHelper";
import _ from "lodash";

const debug = _debug(`${process.env.VUE_APP_PREFIX}:RolesStore`);

export const useRolesStore = defineStore(
  "roles",
  createStore({
    state: {
      roles: {},
    },

    getters: {
      rolesList: (state) => _.values(state.roles),
    },

    actions: {
      async load() {
        debug("load");
        const roles = await ApiClient.get(`/roles`);
        debug("load", roles);
        this.set("roles", _.keyBy(roles, "roleId"));
      },
    },
  }),
);
